module.exports = __webpack_public_path__ + "static/media/landing3.b2595495.svg";